<template>
  <el-button :icon='icon' :size='size' :type='type' :disabled="handleDisabled(permissions)|| disabled" :loading="loading">
    <slot></slot>
  </el-button>
</template>
<script>
export default {
  /**
   * @param {Array} downloading 直接传数组已知数组
   */
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    permissions: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    // 禁用的另外条件
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    type: {
      type: String,
      default: 'primary '
    }
  },
  data () {
    return {
      // permissionsList: []
    }
  },

  computed: {
    permissionsList () {
      return JSON.parse(sessionStorage.getItem('Permissions')) || []
    }
  },
  created () {

  },
  methods: {
    handleDisabled (permissions) {
      // console.log('permissions',permissions)
      // let role = sessionStorage.getItem('role')
      // if (role == 'admin') {
      //   return false
      // } else {
      //   return !this.permissionsList.includes(permissions)
      // }
      // if(permissions.includes('&&')){
      //   permissions.split('&&')
      // }
      return !this.permissionsList.includes(permissions)
    }
  }
}
</script>

<style lang="stylus"  scoped></style>



// WEBPACK FOOTER //
// src/components/limitBtn/index.vue